
































import {Component, Mixins} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {$, PageCollection, pushByName, success} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import Alerta from '@/model/resource/Alerta'
import {Role} from '../../enums/Role'

const metaInfo = () => ({
  title: $.t('view.manage.alertList.title'),
})

@Component({
  metaInfo,
})
export default class ManageAlertTypeListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('auth/role') role!: Role

  Role = Role
  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(Alerta, {}, 10)

  async removerAlerta(item: number) {
    const alert = new Alerta()
    await alert.removeAlerta(item)
    success('system.success.persist')
    this.collection.remove(item)
  }

}
